import React, { useEffect, useState } from 'react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/effect-coverflow';
import { useLocale, useTranslations } from 'next-intl';
import Banner from '@/components/commons/Banner';
import AddCustomerService from '@/components/commons/AddCustomerService';
import Image from 'next/image';
import { successCasesList } from '@/components/home/HomeContent';
import { getAllPosts } from '@/services/gonggongjiekou';
import { scrollToElement } from '@/shared/utils/tools';
import { useRouter } from 'next/router';
import Head from '@/components/commons/Head';
import Masonry from 'react-masonry-css';

export interface ImmgrationProps {
  value: string;
  label: string;
  enLabel: string;
  link?: string;
  suspended?: boolean; // 标识项目是否已暂停
  children?: ImmgrationProps[];
}

// 移民列表数据 -- 数据有三级
export const immgrationTree: ImmgrationProps[] = [
  {
    value: '加拿大',
    label: '加拿大',
    enLabel: 'Canada',
    children: [
      {
        value: '商业类/特需类 移民',
        label: '商业类/特需类 移民',
        enLabel: 'Business Stream',
        children: [
          {
            value: '魁省杰出人才移民项目',
            label: '魁省杰出人才移民项目',
            enLabel: 'Quebec Exceptional Talent Program',
            link: '/quebec-exceptional-talenent/',
          },
          {
            value: 'BC省企业家移民项目 (BCPNP-EI)',
            label: 'BC省企业家移民项目 (BCPNP-EI)',
            enLabel: 'BC Provincial Nominee Program-Entrepreneur Immigration',
            link: '/immigration/investment%20entrepreneur%20immig/bc%20entrpreneur%20immigration/',
          },
          {
            value: 'BC省十万小镇试点项目',
            label: 'BC省十万小镇试点项目',
            enLabel: 'BC Entrepreneur Immigration-Regional Pilot to communities',
            link: '/immigration/investment%20entrepreneur%20immig/bc%20small%20town%20immigration/',
          },
          {
            value: '曼省企业家移民项目（MPNP-EI）',
            label: '曼省企业家移民项目（MPNP-EI）',
            enLabel: 'Manitoba Provincial Nominee Program-Entrepreneur Immigration',
            link: '/immigration/investment-entrepreneur-immig/mpnp-entrepreneur-immigration/',
          },
          {
            value: 'PEI企业家',
            label: 'PEI企业家移民项目（PEIPNP-EI）',
            enLabel: 'Prince Edward Island Provincial Nominee Program-Entrepreneur Immigration',
            link: '/pei%E4%BC%81%E4%B8%9A%E5%AE%B6%E7%A7%BB%E6%B0%91/',
          },
          {
            value: '纽省企业家移民',
            label: '纽省企业家移民项目（NLPNP-EI）',
            enLabel: 'Newfoundland and Labrador Provincial Nominee-Entrepreneur Immigration',
            link: '/nlpnp-entrepreneur/',
          },
          {
            value: '魁省投资移民',
            label: '魁省投资移民项目 （QIIP）',
            enLabel: 'Quebec Immigrant Investor Program',
            link: '/immigration/investment entrepreneur immig/quebec invsetment immigration/',
          },
          {
            value: '魁省企业家移民',
            label: '魁省企业家移民项目',
            enLabel: 'Quebec Entrepreneur Program',
            link: '/immigration/investment%20entrepreneur%20immig/quebec%20entreprenure%20immigation/',
          },
          {
            value: '萨省企业家移民（已暂停）',
            label: '萨省企业家移民项目',
            enLabel: 'Saskatchewan Entrepreneur Category',
            link: '/immigration/investment%20entrepreneur%20immig/sask%20entrepreneur%20category/',
            suspended: true,
          },
          {
            value: '联邦护工（保姆）移民试点（已暂停）',
            label: '联邦护工（保姆）移民试点项目',
            enLabel: 'Home Care Worker Immigration Pilots',
            link: '/immigration/special%20offer%20immigration/nursing%20immigation/',
            suspended: true,
          },
          {
            value: '联邦创业移民（SUV）（已暂停）',
            label: '联邦创业移民项目（SUV）',
            enLabel: 'Start-up Visa Program',
            link: '/canada-start-up-visa/',
            suspended: true,
          },
          {
            value: '联邦自雇移民（已暂停）',
            label: '联邦自雇移民项目',
            enLabel: 'Self-Employed Persons Program',
            link: '/immigration/special%20offer%20immigration/self%20employee%20immigration/',
            suspended: true,
          },
        ],
      },
      {
        value: '雇主担保类技术移民',
        label: '雇主担保类技术移民',
        enLabel: '/',
        children: [
          {
            value: '联邦偏远地区移民试点（RCIP）',
            label: '联邦偏远地区移民试点项目（RCIP）',
            enLabel: 'Rural Community Immigration Pilot',
            link: '/加拿大阿省rrs偏远地区雇主担保移民/',
          },
          {
            value: '大西洋四省雇主担保移民',
            label: '大西洋四省雇主担保移民项目（AIP）',
            enLabel: 'Atlantic Immigration Program',
            link: '/immigration/skilled%20employer%20immigration/atlantic%20immigration%20program/',
          },
          {
            value: 'BC省雇主担保技术移民（BCPNP）',
            label: 'BC省雇主担保移民项目（BCPNP）',
            enLabel: 'British Columbia Provincial Nominee Program',
            link: '/bc%e7%9c%81%e7%9c%81%e6%8f%90%e5%90%8d%e6%8a%80%e6%9c%af%e7%a7%bb%e6%b0%91-bcpnp-skilled-immigration-programs/',
          },
          {
            value: '安省雇主担保技术移民（OINP）',
            label: '安省雇主担保移民项目（OINP）',
            enLabel: 'Ontario Immigration Nominee Program',
            link: '/%e5%ae%89%e7%9c%81%e7%9c%81%e6%8f%90%e5%90%8d%e6%8a%80%e6%9c%af%e7%a7%bb%e6%b0%91-oinp-skilled-immigration-2/',
          },
          {
            value: '阿省雇主担保技术移民（AOS）',
            label: '阿省雇主担保移民项目（AAIP）',
            enLabel: 'Alberta Adventure Immigration Program',
            link: '/%E9%98%BF%E5%B0%94%E4%BC%AF%E5%A1%94%E7%9C%81%E6%8F%90%E5%90%8D%E9%9B%87%E4%B8%BB%E6%8B%85%E4%BF%9D%20%E6%9C%BA%E9%81%87%E7%B1%BB/',
          },
          {
            value: '萨省雇主担保技术移民（SINP）',
            label: '萨省雇主担保移民项目（SINP）',
            enLabel: 'Saskatchewen Immigration Nominee Program',
            link: '/%e8%90%a8%e7%9c%81%e7%9c%81%e6%8f%90%e5%90%8d%e9%9b%87%e4%b8%bb%e6%8b%85%e4%bf%9d%e7%a7%bb%e6%b0%91%e9%a1%b9%e7%9b%ae-sinp-job-offer-categories/',
          },
          {
            value: '曼省雇主担保技术移民（MPNP）',
            label: '曼省雇主担保移民项目（MPNP）',
            enLabel: 'Manitoba Provincial Nominee Program',
            link: '/mpnp%20in%20province%20skilled%20worker%EF%BC%88employer%20direct%20recruitment%20pathway%EF%BC%89/',
          },
          {
            value: '纽省雇主担保技术移民（NLPNP）',
            label: '纽省雇主担保移民项目（NLPNP）',
            enLabel: 'Newfoundland and Labrador Provincial Nominee Program',
            link: '/%e7%ba%bd%e8%8a%ac%e5%85%b0%e9%9b%87%e4%b8%bb%e6%8b%85%e4%bf%9d%e7%9c%81%e6%8f%90%e5%90%8d%e6%8a%80%e6%9c%af%e5%b7%a5%e4%ba%ba%e7%b1%bb-nlpnp-skilled-worker-category/',
          },
          {
            value: '新斯科舍省雇主担保技术移民（NSNP）',
            label: '新斯科舍省雇主担保移民项目（NSNP）',
            enLabel: 'Nova Scotia Nominee Program',
            link: '/%e6%96%b0%e6%96%af%e7%a7%91%e8%88%8d%e7%9c%81%e7%9c%81%e6%8f%90%e5%90%8d%e9%a1%b9%e7%9b%ae-nsnp/',
          },
        ],
      },
      {
        value: '联邦技术移民快速通道',
        label: '联邦技术移民快速通道',
        enLabel: 'EXpress Entry',
        children: [
          {
            value: '加拿大经验类',
            label: '加拿大经验类（CEC）',
            enLabel: 'Canadian Experience Class',
            link: '/canada federal express entry/federal cec/',
          },
          {
            value: '联邦技术类',
            label: '联邦技术类（FSW）',
            enLabel: 'Federal Skilled Worker',
            link: '/canada federal express entry/federal skilled worker 2/',
          },
          {
            value: '联邦技工类',
            label: '联邦技工类（FST）',
            enLabel: 'Federal Skilled Trade',
            link: '/canada federal express entry/federal skill trade/',
          },
        ],
      },
      {
        value: '留学|工签转移民',
        label: '留学|工签转移民',
        enLabel: 'Study&VIsa to Immigration',
        children: [
          {
            value: '留学生转移民',
            label: '留学生转移民',
            enLabel: 'Immigration for International Students',
            link: '/international-students-to-canadian-pr/',
          },
          {
            value: 'LMIA工签转移民',
            label: 'LMIA工签转移民',
            enLabel: 'Immigration for LMIA Based Work Permit',
            link: '/加拿大全球人才计划/',
          },
          {
            value: 'ICT工签转移民',
            label: 'ICT工签转移民',
            enLabel: 'Intra-Company Transferee (ICT) Work Permit',
            link: '/work-permit-for-intra-company-transfer/',
          },
          {
            value: '法语工签转移民',
            label: '法语工签转移民',
            enLabel: 'Immigration for Francophone Mobility Work Permit',
            link: '/加拿大法语工签转移民/',
          },
          {
            value: '加拿大假期工签',
            label: '加拿大假期工签',
            enLabel: 'Immigration for Working Holiday Work Permit',
            link: '/加拿大体验计划-canada-international-experience/',
          },
        ],
      },
      {
        value: '家庭团聚类移民',
        label: '家庭团聚类移民',
        enLabel: 'Family SponsorShip',
        children: [
          {
            value: '配偶|伴侣团聚',
            label: '配偶丨伴侣团聚移民',
            enLabel: 'Spouse or Common-Law Partner Immigration Sponsorship',
            link: '/夫妻-伴侣担保移民/',
          },
          {
            value: '父母|祖父母团聚移民',
            label: '父母丨祖父母团聚移民',
            enLabel: 'Parents and grandparents Immigration Sponsorship',
            link: '/immigration/sponsorship programs/parent or grandparent/',
          },
          {
            value: '子女|养子女团聚',
            label: '子女丨养子女团聚移民',
            enLabel: 'Child or Other Dependant Immigration Sponsorship',
            link: '/immigration/sponsorship programs/child or other dependent/',
          },
        ],
      },
    ],
  },
  {
    value: '美国',
    label: '美国',
    enLabel: 'USA',
    children: [
      {
        value: '美国EB-3雇主担保移民',
        label: '美国EB-3雇主担保移民',
        enLabel: 'Employment-Based Immigration: The Third Preference',
        link: '/美国eb-3雇主担保移民/',
      },
      {
        value: '美国EB5投资移民',
        label: '美国EB-5投资移民（免排期）',
        enLabel: 'EB-5 Immigrant Investor Program',
        link: '/美国eb5投资移民/',
      },
      {
        value: '美国杰出人才/国家利益豁免移民',
        label: '美国杰出人才（EB-1A）/国家利益豁免移民',
        enLabel: 'EB-1 Alien of Extraordinary Ability/National Interest Waiver',
        link: '/美国杰出人才移民与国家利益豁免移民（eb1aniw）/',
      },
    ],
  },
  {
    value: '欧洲',
    label: '欧洲',
    enLabel: 'Europe',
    children: [
      {
        value: '土耳其护照项目',
        label: '土耳其【护照项目】',
        enLabel: 'Turkey Citizenship by Investment Program',
        link: '/turkeyimmigration/',
      },
      {
        value: '希腊黄金永居项目',
        label: '希腊【黄金永居项目】',
        enLabel: 'Greece Golden Visa',
        link: '/希腊黄金永居项目/',
      },
      {
        value: '马耳他永居项目',
        label: '马耳他【永居项目】',
        enLabel: 'Malta Malta Permanent Residence Program',
        link: '/马耳他永居项目/',
      },
      {
        value: '葡萄牙永居项目',
        label: '葡萄牙【永居项目】',
        enLabel: 'Portugal Golden Visa',
        link: '/葡萄牙黄金居留许可项目/',
      },
      {
        value: '爱尔兰【投资居留计划】',
        label: '爱尔兰【投资居留计划】',
        enLabel: 'Irish Immigrant Investor Programme',
        link: '/爱尔兰投资居留计划/',
      },
    ],
  },
  {
    value: '亚洲',
    label: '亚洲',
    enLabel: 'Asia',
    children: [
      {
        value: '中国香港高才/优才计划',
        label: '中国香港高才/优才计划',
        enLabel: 'HongKong Top Talent/Talent stream',
        link: '/香港优才项目/',
      },
      {
        value: '日本经验管理签证',
        label: '日本【经营管理&高度人才签证】',
        enLabel: 'Japanese Business Manager Visa & Highly Skilled Professional Visa',
        link: '/日本经营管理签证/',
      },
      {
        value: '新加坡自雇EP移民',
        label: '新加坡自雇EP移民',
        enLabel: 'Singapore Employment Pass',
        link: '/新加坡自雇移民/',
      },
      {
        value: '韩国存款项目',
        label: '韩国存款项目',
        enLabel: 'South Korea Investment Immigration',
        link: '/韩国存款项目/',
      },
    ],
  },
  {
    value: '岛国护照',
    label: '岛国护照',
    enLabel: 'Island Nation',
    children: [
      {
        value: '安提瓜和巴布达',
        label: '安提瓜和巴布达【投资入籍计划】',
        enLabel: 'Antigua and Barbuda Citizenship by Investment Program',
        link: '/安提瓜和巴布达公民身份计划/',
      },
      {
        value: '圣基茨和尼维斯【国民身份计划】',
        label: '圣基茨和尼维斯【国民身份计划】',
        enLabel: 'Saint Kitts and Nevis Citizenship Program',
        link: '/圣基茨pbo捐款移民项目/',
      },
      {
        value: '瓦努阿图【投资入籍计划】',
        label: '瓦努阿图【投资入籍计划】',
        enLabel: 'Vanuatu Citizenship by Investment',
        link: '/瓦努阿图【投资入籍计划】/',
      },
      {
        value: '多米尼克',
        label: '多米尼克【投资入籍计划】',
        enLabel: 'Dominica Citizenship by Investment Program',
        link: '/多米尼克投资入籍计划/',
      },
      {
        value: '圣卢西亚',
        label: '圣卢西亚【国家经济基金（捐献）项目】',
        enLabel: 'Saint Lucia National Economic Fund',
        link: '/圣卢西亚国家经济基金（捐献）项目/',
      },
      {
        value: '格林纳达',
        label: '格林纳达【投资入籍计划】',
        enLabel: 'Grenada Citizenship by Investment Program',
        link: '/',
      },
    ],
  },
  {
    value: '澳洲',
    label: '澳洲',
    enLabel: 'Australia',
    children: [
      {
        value: '澳洲雇主担保移民',
        label: '澳洲雇主担保移民',
        enLabel: 'Skills in Demand Visa and Immigration(subclass 482 and 186)',
        link: '/澳洲494偏远地区雇主担保移民/',
      },
    ],
  },
];

export const countryFlagListImmigration = [
  { enValue: 'Canada', value: '加拿大' },
  { enValue: 'UnitedStates', value: '美国' },
  { enValue: 'Turkey', value: '土耳其' },
  { enValue: 'Malta', value: '马耳他' },
  { enValue: 'HongKong', value: '中国香港' },
  { enValue: 'Japan', value: '日本' },
  { enValue: 'Singapore', value: '新加坡' },
  { enValue: 'Australia', value: '澳洲' },
  { enValue: 'Asia', value: '亚洲' },
  { enValue: 'Europe', value: '欧洲' },
];

const MigrantContent = () => {
  const t = useTranslations();
  const currentLocale = useLocale(); // 当前语言

  const { query } = useRouter();
  const { keyword, country, category } = query; // url连接上带的搜索关键词

  const [activeCountry, setActiveCountry] = useState<string>(''); //选中的国家
  const [secondCategoryList, setSecondCategoryList] = useState<ImmgrationProps[]>([]); //二级菜单
  const [searchSelectedItem, setSearchSelectedItem] = useState<ImmgrationProps | null>(null); //选中的搜索项
  const [searchValue, setSearchValue] = useState<string>('');
  const [successCases11List, setSuccessCases11List] = useState<any[]>([]);
  const [successCases12List, setSuccessCases12List] = useState<any[]>([]);
  const [successCases13List, setSuccessCases13List] = useState<any[]>([]);

  useEffect(() => {
    if (country) {
      const tempActiveCountry = country as string;
      setActiveCountry(tempActiveCountry);
      const tempSecondCategoryList = immgrationTree.find((item) => item.value === tempActiveCountry)?.children || [];
      setSecondCategoryList(tempSecondCategoryList);
    } else {
      setActiveCountry(immgrationTree[0].value);
      setSecondCategoryList(immgrationTree[0]?.children || []);
    }
  }, [category, country]);

  // 查询叶子节点并设置状态的方法
  const findLeafNodeAndSetActive = (tree: ImmgrationProps[], query: string): void => {
    // 内部递归查找方法
    const findNode = (nodes: ImmgrationProps[], target: string, path: string[] = []): any => {
      // 将查询关键字转换为小写，确保大小写不敏感
      const lowerCaseTarget = target.toLowerCase();

      for (const node of nodes) {
        const newPath = [...path, node.value];

        // 将节点的值和标签转换为小写，进行不区分大小写的比较
        const lowerCaseValue = node.value.toLowerCase();
        const lowerCaseLabel = node.label.toLowerCase();
        const lowerCaseEnLabel = node.enLabel ? node.enLabel.toLowerCase() : '';

        // 检查是否与目标模糊匹配
        if (
          lowerCaseValue.includes(lowerCaseTarget) ||
          lowerCaseLabel.includes(lowerCaseTarget) ||
          lowerCaseEnLabel.includes(lowerCaseTarget)
        ) {
          // 如果找到叶子节点（无 children 或 children 为空）
          if (!node.children || node.children.length === 0) {
            return { leafNode: node, path: newPath };
          }
        }
        // 递归查找子节点
        if (node.children) {
          const result = findNode(node.children, target, newPath);
          if (result) return result;
        }
      }
      return null;
    };

    // 开始查找
    const result = findNode(tree, query);

    if (result) {
      console.log(result);
      const { leafNode, path } = result;

      setActiveCountry(path[0]);
      setSecondCategoryList(tree.find((node) => node.value === path[0])?.children || []);
      setSearchSelectedItem(leafNode);
    } else {
      console.warn('未找到匹配的叶子节点');
      setSearchSelectedItem(null);
    }
  };

  const colors = [
    { bg: 'bg-[#cd003a1A]', hover: 'hover:bg-[#CD003A]' },
    { bg: 'bg-[#298ABD1A]', hover: 'hover:bg-[#298ABD]' },
    { bg: 'bg-[#CB4F451A]', hover: 'hover:bg-[#CB4F45]' },
    { bg: 'bg-[#8F4EC61A]', hover: 'hover:bg-[#8F4EC6]' },
    { bg: 'bg-[#3339BE1A]', hover: 'hover:bg-[#3339BE]' },
    { bg: 'bg-[#ED96251A]', hover: 'hover:bg-[#ED9625]' },
    { bg: 'bg-[#06AB8E1A]', hover: 'hover:bg-[#06AB8E]' },
    { bg: 'bg-[#C12C951A]', hover: 'hover:bg-[#C12C95]' },
  ];

  const [showMoreSuccessCases, setShowMoreSuccessCases] = useState<boolean>(false); // 成功案例--查看更多

  // 取catagories= 11，12，13 。 3个id值要全部取出显示，就是成功案例--组成成功案例的更多数据
  useEffect(() => {
    getAllPosts({ categories: 11 }).then((res) => {
      setSuccessCases11List(res?.data || []);
    });
    getAllPosts({ categories: 12 }).then((res) => {
      setSuccessCases12List(res?.data || []);
    });
    getAllPosts({ categories: 13 }).then((res) => {
      setSuccessCases13List(res?.data || []);
    });
  }, []);

  useEffect(() => {
    if (keyword) {
      // 如果有搜索关键字，执行搜索方法
      findLeafNodeAndSetActive(immgrationTree, keyword as string);
    }
  }, [keyword]);

  return (
    <div className="w-full">
      <Head
        title={activeCountry + '移民,专注移民,量身定制方案'}
        description={
          '星环移民，专注加拿大移民和留学十余载，擅长量身定制方案，提供高性价比服务，成功率居行业领先水平。旗下拥有多位全职的ICCRC认证的「加拿大持牌移民顾问」、教育专家和职业培训导师，专业办理加拿大移民、留学、游学、夏令营、教育等服务，提供顾问咨询、签证办理、学校申请、就业指导、财税规划及新移民安家落地、置业创业等一条龙服务，对于解决各种签证、留学、移民疑难问题有丰富经验与成功案例。'
        }
        keywords="移民,海外移民,加拿大移民,全球移民,移民咨询,移民公司,移民中介,星环移民"
      />
      {/* 移民banner */}
      <Banner
        title={t('Immigration.overseasImmigration')}
        subTitlle={t('Immigration.overseasImmigrationEnlishText')}
        onSearch={(value: string) => {
          setSearchValue(value);
          if (value) {
            findLeafNodeAndSetActive(immgrationTree, value);
          }
        }}
        showError={{
          show: !searchSelectedItem && !!searchValue,
          message: t('Bannder.errorText'),
        }}
        onClickConsultCustomerService={() => {
          const element = document.getElementById('addCustomerServiceBox');
          if (element) {
            scrollToElement(element);
          }
        }}
      />
      {/* 移民内容 */}
      <div className="box-border w-full bg-[#E7EEFF] px-[9.36vw] pb-[6.5vw] pt-[1.56vw] max-md:-mt-[138px] max-md:rounded-t-3xl max-md:px-[4%] max-md:pb-[29px] max-md:pt-[18px]">
        {/* 国家级分类 */}
        <div className="mb-[2.6vw] flex w-full flex-row flex-wrap items-center justify-start max-md:mb-7 max-md:grid max-md:grid-cols-4 max-md:gap-0">
          {immgrationTree.map((item, index) => (
            <h2
              className={`mb-[0.5vw] mr-[2.86vw] flex cursor-pointer flex-row items-center justify-center px-[2.288vw] py-[0.728vw] text-center max-md:m-0 max-md:p-0 max-md:py-[9px] ${activeCountry === item.value ? 'rounded-full bg-[#2A2B45] text-[1.144vw] leading-[1.144vw] text-white max-md:rounded-[33px] max-md:text-sm max-md:leading-[14px]' : 'text-[1.04vw] leading-[1.04vw] text-[#333333] max-md:text-sm max-md:leading-[14px]'}`}
              key={index}
              onClick={() => {
                setActiveCountry(item.value);
                setSecondCategoryList(item.children || []);
              }}
            >
              {countryFlagListImmigration.find((country) => country.value === item.value) && (
                <Image
                  src={`/images/home/${countryFlagListImmigration.find((country) => country.value === item.value)?.enValue}.png`}
                  width={34}
                  height={34}
                  className="mr-[0.78vw] size-[1.768vw] max-md:mr-2 max-md:size-5"
                  alt="country"
                />
              )}
              {currentLocale === 'zh' ? item.label : item.enLabel}
            </h2>
          ))}
        </div>
        {/* 移民分类 */}
        {secondCategoryList && secondCategoryList.length > 0 ? (
          <>
            {activeCountry && activeCountry === '加拿大' ? (
              <>
                <Masonry
                  breakpointCols={2}
                  className="my-masonry-grid max-md:hidden"
                  columnClassName="my-masonry-grid_column"
                >
                  {(secondCategoryList || []).map((item, index) => {
                    return (
                      <div key={index} className="mb-[2.08vw] rounded-[1.04vw] bg-[#33367C] max-md:mb-6">
                        <h2 className="box-border flex h-[4.316vw] flex-row items-center justify-start px-[1.872vw] text-left text-[1.248vw] font-medium text-white max-md:h-8 max-md:px-4 max-md:text-[14px]">
                          {item.label}
                        </h2>
                        <div className="rounded-[1.04vw] bg-white px-[1.82vw] pb-[2.756vw] pt-[2.34vw] max-md:p-6 max-md:px-4 max-md:py-4">
                          {(activeCountry === '加拿大' ? item?.children || [] : secondCategoryList || [])?.length >
                          0 ? (
                            <div>
                              {(activeCountry === '加拿大' ? item?.children || [] : secondCategoryList || []).map(
                                (_item, index) => (
                                  <div
                                    className={`mb-[1.976vw] flex cursor-pointer flex-row justify-start text-[0.936vw] font-medium last:mb-0 max-md:text-xs ${
                                      _item.suspended
                                        ? 'text-[#999999] hover:font-medium hover:text-[#999999]'
                                        : 'text-[#2A2B45] hover:font-semibold hover:text-[#19228C]'
                                    }`}
                                    key={index}
                                    onClick={() => {
                                      if (_item?.link) {
                                        const fullLink = _item.link.startsWith('http')
                                          ? _item.link
                                          : process.env.NEXT_PUBLIC_WEBSITE + _item.link;
                                        window.open(fullLink, '_blank');
                                      }
                                    }}
                                  >
                                    <span className="mr-[1.04vw] w-2/5">{_item.label}</span>
                                    <span className="flex-1">{_item.enLabel}</span>
                                  </div>
                                ),
                              )}
                            </div>
                          ) : (
                            <div className="text-center max-md:text-xs">{t('Home.noData')}</div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </Masonry>
                <Masonry
                  breakpointCols={1}
                  className="my-masonry-grid md:hidden"
                  columnClassName="my-masonry-grid_column"
                >
                  {(secondCategoryList || []).map((item, index) => {
                    return (
                      <div key={index} className="mb-[2.08vw] rounded-[1.04vw] bg-[#33367C] max-md:mb-6">
                        <h2 className="box-border flex h-[4.316vw] flex-row items-center justify-start px-[1.872vw] text-left text-[1.248vw] font-medium text-white max-md:h-8 max-md:px-4 max-md:text-[14px]">
                          {item.label}
                        </h2>
                        <div className="rounded-[1.04vw] bg-white px-[1.82vw] pb-[2.756vw] pt-[2.34vw] max-md:p-6 max-md:px-4 max-md:py-4">
                          {(activeCountry === '加拿大' ? item?.children || [] : secondCategoryList || [])?.length >
                          0 ? (
                            <div>
                              {(activeCountry === '加拿大' ? item?.children || [] : secondCategoryList || []).map(
                                (_item, index) => (
                                  <div
                                    className={`mb-[1.976vw] flex cursor-pointer flex-row justify-start text-[0.936vw] font-medium last:mb-0 max-md:text-xs ${
                                      _item.suspended
                                        ? 'text-[#999999] hover:font-medium hover:text-[#999999]'
                                        : 'text-[#2A2B45] hover:font-semibold hover:text-[#19228C]'
                                    }`}
                                    key={index}
                                    onClick={() => {
                                      if (_item?.link) {
                                        const fullLink = _item.link.startsWith('http')
                                          ? _item.link
                                          : process.env.NEXT_PUBLIC_WEBSITE + _item.link;
                                        window.open(fullLink, '_blank');
                                      }
                                    }}
                                  >
                                    <span className="mr-[1.04vw] w-2/5">{_item.label}</span>
                                    <span className="flex-1">{_item.enLabel}</span>
                                  </div>
                                ),
                              )}
                            </div>
                          ) : (
                            <div className="text-center max-md:text-xs">{t('Home.noData')}</div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </Masonry>
              </>
            ) : (
              <div className="w-[36.92vw] max-md:w-full">
                <div className="mb-[2.08vw] rounded-[1.04vw] bg-[#33367C] max-md:mb-6">
                  <h2 className="box-border flex h-[4.316vw] flex-row items-center justify-start px-[1.872vw] text-left text-[1.248vw] font-medium text-white max-md:h-8 max-md:px-4 max-md:text-[14px]">
                    {activeCountry}
                  </h2>
                  <div className="rounded-[1.04vw] bg-white px-[1.82vw] pb-[2.756vw] pt-[2.34vw] max-md:p-6 max-md:px-4 max-md:py-4">
                    {(secondCategoryList || [])?.length > 0 ? (
                      <div>
                        {(secondCategoryList || []).map((_item, index) => (
                          <div
                            className={`mb-[1.976vw] flex cursor-pointer flex-row justify-start text-[0.936vw] font-medium last:mb-0 max-md:text-xs ${
                              _item.suspended
                                ? 'text-[#999999] hover:font-medium hover:text-[#999999]'
                                : 'text-[#2A2B45] hover:font-semibold hover:text-[#19228C]'
                            }`}
                            key={index}
                            onClick={() => {
                              if (_item?.link) {
                                const fullLink = _item.link.startsWith('http')
                                  ? _item.link
                                  : process.env.NEXT_PUBLIC_WEBSITE + _item.link;
                                window.open(fullLink, '_blank');
                              }
                            }}
                          >
                            <span className="mr-[1.04vw] w-2/5">{_item.label}</span>
                            <span className="flex-1">{_item.enLabel}</span>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="text-center max-md:text-xs">{t('Home.noData')}</div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </>
        ) : (
          <div className="text-center max-md:text-xs">{t('Home.noData')}</div>
        )}
      </div>
      {/* 添加客服 */}
      <AddCustomerService />
      {/* 常见问题 */}
      <div className="mb-[3.328vw] mt-[4.576vw] w-full max-md:mb-[60px] max-md:mt-[38px]">
        <div className="box-border w-full px-[9.672vw] max-md:px-[4%]">
          <h2 className="mb-[1.04vw] text-[2.08vw] font-medium leading-[2.08vw] text-[#2A2B45] max-md:mb-[10px] max-md:text-xl max-md:leading-5">
            {t('Immigration.faq')}
          </h2>
          <h2 className="mb-[3.796vw] text-[1.56vw] font-bold uppercase leading-[1.56vw] text-[#2A2B45] opacity-20 max-md:mb-[18px] max-md:text-lg max-md:leading-[18px]">
            {t('Immigration.faqEnglishText')}
          </h2>
        </div>
        <div className="box-border grid w-full grid-cols-4 gap-x-[1.468vw] px-[11.856vw] max-md:grid max-md:grid-cols-2 max-md:gap-[10px] max-md:px-[2%]">
          {[
            { url: '/加拿大「持牌移民顾问」是怎样炼成的-远离非法/' },
            { url: '/详解加拿大移民监-居住时间不够怎么办/' },
            { url: '/加拿大永居or入籍/' },
            { url: '/加拿大报税解读/' },
            { url: '/租车购车与驾照/' },
            { url: '/加拿大工作签证（work-permit）全解析：种类、申请条件与/' },
            { url: '/加拿大陪读家长如何移民？星环移民带你看清2025年/' },
            { url: '/英语不好，还能移民加拿大吗？/' },
          ].map((item, index) => {
            const { bg, hover } = colors[index];
            return (
              <div
                key={index}
                className={`group mb-[1.768vw] flex h-[8.32vw] cursor-pointer flex-col items-center justify-center rounded-[20px] max-md:m-0 max-md:h-20 max-md:w-full max-md:px-4 ${bg} ${hover}`}
                onClick={() => {
                  window.open(process.env.NEXT_PUBLIC_WEBSITE + item.url, '_blank');
                }}
              >
                <h3 className="mb-[0.832vw] text-center text-[0.936vw] font-medium leading-[0.936vw] text-[#2A2B45] group-hover:text-white max-md:mb-[7px] max-md:text-[12px] max-md:leading-[12px]">
                  {t(`Immigration.faqTitle${index + 1}` as any)}
                </h3>
                <h3 className="px-[0.728vw] text-center text-[0.728vw] leading-[0.728vw] text-[#666666] group-hover:text-white max-md:px-[10px] max-md:text-[10px] max-md:leading-[10px]">
                  {t(`Immigration.faqSubTitle${index + 1}` as any)}
                </h3>
              </div>
            );
          })}
        </div>
      </div>
      {/* 成功案例 */}
      <div
        style={{
          background: 'linear-gradient(180deg, #ffffff 0%, #E7EEFF 100%)',
        }}
        className="w-full pb-[5.72vw] max-md:pb-[97px]"
      >
        <div className="box-border w-full px-[9.672vw] max-md:px-[4%]">
          <h5 className="mb-[1.04vw] text-[2.08vw] font-medium leading-[2.08vw] text-[#2A2B45] max-md:mb-[10px] max-md:text-xl max-md:leading-5">
            {t('Immigration.successCases')}
          </h5>
          <h5 className="mb-[3.796vw] text-[1.56vw] font-bold uppercase leading-[1.56vw] text-[#2A2B45] opacity-20 max-md:mb-[18px] max-md:text-lg max-md:leading-[18px]">
            {t('Immigration.successCasesEnglishText')}
          </h5>
        </div>
        <div className="mb-[2.704vw] box-border grid w-full grid-cols-2 gap-[2.704vw] px-[11.168vw] max-md:mb-[26px] max-md:grid-cols-1 max-md:gap-x-0 max-md:gap-y-[15px] max-md:px-[4%]">
          {successCasesList.map((item, index) => (
            <div
              key={index}
              className="w-full cursor-pointer"
              onClick={() => {
                if (item.link) {
                  if (item.link.startsWith('http') || item.link.startsWith('https')) {
                    window.open(item.link, '_blank');
                  } else {
                    window.open(`${process.env.NEXT_PUBLIC_WEBSITE}${item.link}`, '_blank');
                  }
                }
              }}
            >
              <div
                style={{ backgroundImage: `url(${item.image_1})` }}
                className={`h-[20.28vw] w-full bg-slate-600 bg-cover bg-no-repeat max-md:h-[195px] ${index === 0 ? 'bg-center' : 'bg-center'}`}
              ></div>
              <div className="box-border flex min-h-[7.592vw] w-full flex-col items-start justify-center bg-white px-[1.872vw] max-md:min-h-[72px] max-md:px-5 max-md:pb-[19px] max-md:pt-[15px]">
                <div className="mb-[1.456vw] font-medium leading-[1.04vw] text-[#2A2B45] max-md:mb-2 max-md:text-[15px] max-md:leading-normal">
                  {item.title}
                </div>
                {/* <div className="text-[0.832vw] leading-normal text-[#666666] max-md:text-xs">{item.date} 成功案例</div> */}
              </div>
            </div>
          ))}
        </div>
        <div className="flex w-full flex-row items-center justify-center">
          <div
            className={`mb-[1.872vw] box-border flex h-[2.288vw] w-[5.2vw] cursor-pointer flex-row items-center justify-center rounded-[22px] border-[2px] border-solid border-[#2A2B45] text-[0.936vw] text-[#2A2B45] ${showMoreSuccessCases ? 'max-md:mb-[28px]' : 'max-md:mb-0'} max-md:h-[30px] max-md:w-[75px] max-md:text-[13px] max-md:leading-none`}
            onClick={() => {
              setShowMoreSuccessCases(!showMoreSuccessCases);
            }}
          >
            <div className="user-select-none mr-[0.208vw] cursor-pointer max-md:mr-2">{t('Immigration.more')}</div>
            <Image
              src={'/images/common/arrow.png'}
              width={15}
              height={9}
              className={`user-select-none h-auto w-[0.78vw] cursor-pointer transition-all max-md:w-2 ${showMoreSuccessCases ? 'rotate-0' : 'rotate-180'}`}
              alt="search"
            />
          </div>
        </div>
        {showMoreSuccessCases && (
          <div className="grid w-full grid-cols-1 gap-[1.04vw] px-[11.168vw] max-md:gap-x-0 max-md:gap-y-[10px] max-md:px-[4%] md:grid-cols-2 xl:grid-cols-3">
            {[...successCases11List, ...successCases12List, ...successCases13List].map((item, index) => (
              <div
                key={index}
                className="flex h-[6.24vw] cursor-pointer flex-col items-center justify-center bg-white px-[2.088vw] text-center text-[0.936vw] leading-normal text-[#2A2B45] hover:bg-[#C7C9FF] max-md:h-[60px] max-md:px-11 max-md:text-xs"
                onClick={() => {
                  const link = item?.link;
                  if (link) {
                    if (link.startsWith('http') || link.startsWith('https')) {
                      window.open(link, '_blank');
                    } else {
                      window.open(`${process.env.NEXT_PUBLIC_WEBSITE}${link}`, '_blank');
                    }
                  }
                }}
              >
                {item?.title?.rendered}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MigrantContent;
